import fetch from "isomorphic-unfetch";
import { OfferSelectedParams } from "../../../modules/common/context/quoteFormConnector/types";

type FindOrCreateOfferSale = (url: string) => Promise<OfferSelectedParams>;

/* eslint-disable @typescript-eslint/camelcase */
type FindOrCreateOfferSaleResponse = Record<"access_code" | "offer_id" | "sale_id", string>;

const errorMessageBuilder = (url: string, status: string | number) =>
  `Error ${status} finding or creating the sale from ${url}`;

const handleLegacyOfferIdResponse = ({
  offer_id,
  access_code,
  sale_id
}: FindOrCreateOfferSaleResponse) => ({
  accessCode: access_code,
  formId: "",
  offerId: String(offer_id),
  saleId: String(sale_id)
});
/* eslint-enable */

const handleFetch = (response: Response) => {
  if (!response.ok) {
    const { url, status } = response;
    throw new Error(errorMessageBuilder(url, status));
  }

  return response.json() as Promise<FindOrCreateOfferSaleResponse>;
};

export const findOrCreateOfferSale: FindOrCreateOfferSale = url =>
  fetch(url, { method: "POST" })
    .then(handleFetch)
    .then(handleLegacyOfferIdResponse);
